const features = [
  {
    icon: 'ri-speed-up-line',
    title: '秒开极速播放',
    desc: '多线CDN智能加速与H.265编码技术，点击即播无需等待缓冲。无论是1080P超清还是4K画质，均能在主流网络环境下实现秒级加载，流畅追剧不卡顿。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '免费全集畅享',
    desc: '全站所有电视剧资源无需注册登录、无需付费订阅即可免费在线观看。从热门新剧到经典老剧，从国产剧到海外剧，全集开放无限制。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '编辑团队全天候跟进各大平台首播排期，确保最新电视剧资源在播出后第一时间同步上线。追剧日历自动匹配，不错过任何一集更新。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
            <i className="ri-star-line text-primary-500 text-sm"></i>
            <span className="text-primary-400 text-xs font-medium">平台特色</span>
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">为什么选择我们</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">
            三大核心优势打造极致追剧体验，高清不卡流畅秒开
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {features.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/60 rounded-xl p-6 hover:border-primary-500/20 transition-all group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500/15 mb-5 group-hover:bg-primary-500/25 transition-colors">
                <i className={`${item.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="text-foreground-800 font-heading font-bold text-base mb-3">{item.title}</h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}